import { GetNotificationAlertsResponseSchema, type GetNotificationAlertsResponse } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export const USE_NOTIFICATIONS_QUERY_KEY = 'notifications';

export function useGetNotifications(options?: CustomUseQueryOptions<GetNotificationAlertsResponse>) {
  return useQuery(
    [USE_NOTIFICATIONS_QUERY_KEY],
    async () => {
      const privateApi = getPrivateApi();
      const notifications = await privateApi.getNotificationAlerts();

      return GetNotificationAlertsResponseSchema.parse(notifications);
    },
    options,
  );
}